(function () {
  const dock = document.querySelector('[data-clikea-contact-dock]');
  const trigger = dock?.querySelector('[data-clikea-open-inbox]');
  const image = dock?.querySelector('[data-clikea-contact-toggle] img');
  const prompt = dock?.querySelector('[data-clikea-prompt]');
  const actions = dock?.querySelector('.clikea-contact-dock__actions');
  if (!dock || !trigger || !image || !actions) return;
  const humanSupport = document.querySelector('[data-clikea-human-support]');
  const humanStatus = humanSupport?.querySelector('[data-clikea-human-status]');
  const workdays = new Set((humanSupport?.dataset.clikeaWorkdays || '').split(',').filter(Boolean).map(Number));
  let availabilityTimer = null;
  const mexicoClock = new Intl.DateTimeFormat('en-US', {timeZone:'America/Mexico_City', year:'numeric', month:'numeric', day:'numeric', hour:'numeric', minute:'numeric', second:'numeric', hourCycle:'h23'});
  function updateAvailability() {
    clearTimeout(availabilityTimer);
    availabilityTimer = null;
    if (!humanSupport || document.hidden) return;
    const now = new Date();
    const parts = Object.fromEntries(mexicoClock.formatToParts(now).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
    const midnight = Date.UTC(parts.year, parts.month - 1, parts.day);
    const day = new Date(midnight).getUTCDay();
    const minute = parts.hour * 60 + parts.minute;
    const available = workdays.has(day) && minute >= 9 * 60 && minute < 15 * 60;
    const description = available ? 'Atención humana disponible ahora · Lunes a sábado, 9 a.m. a 3 p.m., hora del centro de México' : 'Fuera del horario de atención humana · Lunes a sábado, 9 a.m. a 3 p.m., hora del centro de México. Puedes dejarnos un mensaje';
    humanSupport.dataset.clikeaAvailable = String(available);
    humanSupport.setAttribute('title', 'WhatsApp · ' + description);
    humanSupport.setAttribute('aria-label', 'Hablar con un agente humano por WhatsApp. ' + description);
    if (humanStatus) humanStatus.hidden = false;
    // One timer at the next opening/closing boundary, with no minute polling.
    const offset = midnight + (parts.hour * 3600 + parts.minute * 60 + parts.second) * 1000 - Math.floor(now.getTime() / 1000) * 1000;
    let nextBoundary = Infinity;
    for (let days = 0; days <= 7; days += 1) {
      const date = midnight + days * 24 * 60 * 60 * 1000;
      if (!workdays.has(new Date(date).getUTCDay())) continue;
      for (const hour of [9, 15]) {
        const boundary = date + hour * 60 * 60 * 1000 - offset;
        if (boundary > now.getTime()) nextBoundary = Math.min(nextBoundary, boundary);
      }
    }
    if (Number.isFinite(nextBoundary)) availabilityTimer = setTimeout(updateAvailability, nextBoundary - now.getTime() + 100);
  }
  updateAvailability();
  const toggle = dock.querySelector('[data-clikea-contact-toggle]');
  const veil = document.querySelector('[data-clikea-contact-veil]');
  const cartPage = document.querySelector('.clu-cart-page');
  if (cartPage) dock.dataset.clikeaCart = 'true';
  let cartScrollTimer = null, cartScrolling = false;
  const persistent = dock.dataset.clikeaPersistent === 'true';
  const focusTarget = toggle;
  function setContactsExpanded(open) {
    open = Boolean(open);
    dock.dataset.clikeaExpanded = String(open);
    if (veil) veil.hidden = !open;
    actions.inert = !open;
    actions.setAttribute('aria-hidden', String(!open));
    toggle?.setAttribute('aria-expanded', String(open));
    toggle?.setAttribute('aria-label', open ? 'Cerrar opciones de ayuda' : 'Abrir opciones de ayuda');
  }
  function closeContacts(restoreFocus = false) {
    // All Cliki menus fold, including the homepage.
    const focusInside = actions.contains(document.activeElement);
    if (focusInside) focusTarget?.focus({preventScroll:true});
    setContactsExpanded(false);
    pausePrompt();
  }
  const confirmationPage = /\/(?:checkouts|thank_you|thank-you)(?:\/|$)/.test(location.pathname);
  actions.hidden = false;
  setContactsExpanded(dock.dataset.clikeaDefaultExpanded === 'true' && !confirmationPage && !cartPage);
  toggle?.addEventListener('click', () => {setContactsExpanded(dock.dataset.clikeaExpanded !== 'true'); if (dock.dataset.clikeaExpanded !== 'true') pausePrompt(); schedule();});
  document.addEventListener('pointerdown', event => {if (!dock.contains(event.target)) closeContacts();});
  document.addEventListener('focusin', event => {if (!dock.contains(event.target)) closeContacts();});
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && dock.dataset.clikeaExpanded === 'true') {
      closeContacts(true);
      if (document.activeElement === toggle) event.preventDefault();
    }
  });
  actions.addEventListener('click', event => {if (event.target.closest('a')) closeContacts(true);});
  window.addEventListener('pagehide', () => {closeContacts();pausePrompt();clearTimeout(availabilityTimer);availabilityTimer=null;clearTimeout(cartScrollTimer);cartScrollTimer=null;});
  window.addEventListener('pageshow', () => {updateAvailability();schedule();});
  let frame = null, trackedButton = null, trackedChat = null, discovery = null, wasOpen = false;
  const chatStateObserver = new MutationObserver(schedule);
  const watchedRoots = new WeakSet();
  const resize = new ResizeObserver(schedule);
  resize.observe(actions);
  const mobile = matchMedia('(max-width: 980px)');
  const purchaseBar = document.querySelector('.clpdp-sticky,[data-clc-mobile-pay]');
  const protectedProductElements = [...document.querySelectorAll('.clpdp-title,.clpdp-price,.clpdp-stock-row,.clpdp-options,.clpdp-mobile-thumbnails')];
  const cartControls = cartPage ? [...cartPage.querySelectorAll('button,a,input,select,textarea,summary'), ...document.querySelectorAll('[data-clc-mobile-pay] button')] : [];
  if (cartPage) resize.observe(cartPage);
  cartControls.forEach(element => resize.observe(element));
  protectedProductElements.forEach(element => resize.observe(element));
  if (purchaseBar) {
    resize.observe(purchaseBar);
    new MutationObserver(schedule).observe(purchaseBar, {attributes:true, attributeFilter:['style','class']});
  }
  function placeDock(bottom = mobile.matches ? 18 : 38) {
    const stickyHeight = purchaseBar && getComputedStyle(purchaseBar).display !== 'none' ? Math.ceil(purchaseBar.getBoundingClientRect().height) : 0;
    document.body.style.setProperty('--clux-sticky-height', stickyHeight + 'px');
    if (visualViewport) bottom = Math.max(bottom, innerHeight - visualViewport.height - visualViewport.offsetTop + 18);
    if (purchaseBar && getComputedStyle(purchaseBar).display !== 'none') {
      const box = purchaseBar.getBoundingClientRect();
      if (box.height > 0) bottom = Math.max(bottom, Math.ceil(Math.max(box.height, innerHeight - box.top)) + 12);
    }
    // Keep the launcher anchored below; protect message bubbles without lifting the dock.
    dock.style.setProperty('--clikea-contact-bottom', 'calc(' + bottom + 'px + env(safe-area-inset-bottom))');
    dock.classList.remove('clikea-contact-obstructed');
    if (cartPage && dock.dataset.clikeaExpanded !== 'true') {
      const box = dock.getBoundingClientRect();
      const collision = [...cartControls, ...cartPage.querySelectorAll('.clc-cart-line,[data-clc-wholesale]')].some(element => {
        const control = element.getBoundingClientRect();
        return control.width > 0 && control.height > 0 && control.bottom > 0 && control.top < innerHeight
          && box.left < control.right + 8 && box.right > control.left - 8
          && box.top < control.bottom + 8 && box.bottom > control.top - 8;
      });
      dock.classList.toggle('clikea-contact-obstructed', cartScrolling || collision);
    }
  }
  // Three brief invitations, then five quiet minutes; timers stop while hidden.
  const promptMessages = ['Soy Cliki, disponible 24/7', 'Te ayudo con tu compra', 'Pregúntame tus dudas'];
  const promptObstacles = [...protectedProductElements, ...cartControls, ...document.querySelectorAll('[data-clux-home-price],.clpdp-media-track,.clpdp-purchase,.clpdp-sticky,.clu-header,.cls-header')];
  // Gallery/header/font changes can move a visible invitation without scrolling.
  promptObstacles.forEach(element => resize.observe(element));
  let promptTimer = null, promptStep = 0, nextPromptAt = Date.now() + 4000;
  function canShowPrompt() {
    return prompt && !cartPage && !document.hidden && !dock.hidden && dock.dataset.clikeaExpanded !== 'true'
      && getComputedStyle(dock).visibility === 'visible'
      && !document.querySelector('shopify-chat')?.hasAttribute('open');
  }
  function promptFits() {
    const box = prompt.getBoundingClientRect();
    if (box.left < 4 || box.right > innerWidth - 8 || box.top < 8 || box.bottom > innerHeight - 8) return false;
    return !promptObstacles.some(element => {
      const other = element.getBoundingClientRect();
      return other.width > 0 && other.height > 0 && box.right > other.left - 4 && box.left < other.right + 4
        && box.bottom > other.top - 4 && box.top < other.bottom + 4;
    });
  }
  function pausePrompt() {
    clearTimeout(promptTimer);
    promptTimer = null;
    prompt?.classList.remove('is-visible');
    nextPromptAt = Math.max(nextPromptAt, Date.now() + 4000);
  }
  function showNextPrompt() {
    promptTimer = null;
    if (!canShowPrompt()) return;
    if (promptStep >= promptMessages.length) promptStep = 0;
    prompt.textContent = promptMessages[promptStep];
    if (!promptFits()) return;
    promptStep += 1;
    // Preserve the quiet period even if scroll/chat interrupts the last invitation.
    nextPromptAt = Date.now() + 4000 + (promptStep >= promptMessages.length ? 5 * 60 * 1000 : 8000);
    prompt.classList.add('is-visible');
    promptTimer = setTimeout(() => {
      prompt.classList.remove('is-visible');
      promptTimer = null;
      nextPromptAt = Date.now() + (promptStep >= promptMessages.length ? 5 * 60 * 1000 : 8000);
      schedulePromptCycle();
    }, 4000);
  }
  function schedulePromptCycle() {
    if (prompt?.classList.contains('is-visible') && (!canShowPrompt() || !promptFits())) pausePrompt();
    if (!canShowPrompt() || promptTimer !== null) return;
    promptTimer = setTimeout(showNextPrompt, Math.max(0, nextPromptAt - Date.now()));
  }
  function schedule() { if (frame !== null) return; frame = requestAnimationFrame(() => {frame=null;sync();}); }
  function findActivator(root) {
    if (!watchedRoots.has(root)) {
      watchedRoots.add(root);
      new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class','open','aria-expanded']});
    }
    const direct = root.querySelector('[part="activator"]');
    if (direct) return direct;
    for (const element of root.querySelectorAll('*')) if (element.shadowRoot) {const b=findActivator(element.shadowRoot);if(b)return b;}
    return null;
  }
  // WhatsApp is authored inside the menu; no independent floating launcher.
  function sync() {
    const chat = document.querySelector('shopify-chat');
    if (chat && chat !== trackedChat) {
      chatStateObserver.disconnect();
      trackedChat = chat;
      chatStateObserver.observe(chat, {attributes:true, attributeFilter:['open']});
    }
    // Inbox can re-render interactive shadow children while its host is hidden.
    // Inert prevents that closed layer from intercepting our launcher's clicks.
    if (chat) chat.inert = !chat.hasAttribute('open');
    if (mobile.matches) {
      dock.hidden = false;
      placeDock();
      document.body.classList.add('clikea-contact-dock-ready');
      const open = chat?.hasAttribute('open') ?? false;
      if (wasOpen && !open) focusTarget?.focus({preventScroll:true});
      wasOpen = open;
      if (open) pausePrompt();
      else schedulePromptCycle();
      return;
    }
    dock.hidden = false;
    document.body.classList.add('clikea-contact-dock-ready');
    placeDock();
    if (!chat?.shadowRoot) return;
    const open = chat.hasAttribute('open');
    if (wasOpen && !open && !dock.hidden) focusTarget?.focus({preventScroll:true});
    if (wasOpen && !open) schedulePromptCycle();
    if (open) pausePrompt();
    wasOpen = open;
    discovery?.disconnect();
    const button = findActivator(chat.shadowRoot);
    if (!button || typeof chat.show !== 'function' || !image.complete || !image.naturalWidth) return;
    if (button !== trackedButton) {if(trackedButton)resize.unobserve(trackedButton);trackedButton=button;resize.observe(button);}
    const box=button.getBoundingClientRect();
    if (!box.width || !box.height || chat.hasAttribute('open')) return;
    dock.hidden=false;document.body.classList.add('clikea-contact-dock-ready');
    placeDock();
    schedulePromptCycle();
  }
  dock.querySelector('[data-clikea-contact-close]')?.addEventListener('click', () => closeContacts(true));
  trigger.addEventListener('click', () => {
    pausePrompt();
    const chat = document.querySelector('shopify-chat');
    if (typeof chat?.show === 'function') {
      closeContacts();
      chat.inert = false;
      chat.show();
    } else {
      dock.querySelector('[data-clikea-inbox-fallback]').hidden = false;
    }
  });
  document.addEventListener('visibilitychange',() => {
    if (document.hidden) {closeContacts();pausePrompt();clearTimeout(availabilityTimer);availabilityTimer=null;clearTimeout(cartScrollTimer);cartScrollTimer=null;cartScrolling=false;}
    else {updateAvailability();schedule();}
  });
  image.addEventListener('load',schedule,{once:true});
  customElements.whenDefined('shopify-chat').then(schedule);
  window.addEventListener('load',schedule,{once:true});
  window.addEventListener('resize',schedule);
  visualViewport?.addEventListener('resize',schedule);
  visualViewport?.addEventListener('scroll',schedule);
  window.addEventListener('scroll', () => {
    if (cartPage) {
      closeContacts();
      cartScrolling = true;
      clearTimeout(cartScrollTimer);
      cartScrollTimer = setTimeout(() => {cartScrolling=false;cartScrollTimer=null;schedule();}, 450);
    }
    if (protectedProductElements.length || persistent || cartPage) schedule();
  }, {passive:true});
  window.addEventListener('message',event=>{const bar=document.querySelector('iframe#PBarNextFrame');if(bar&&event.source===bar.contentWindow)schedule();});
  const globalMenu = document.querySelector('.clu-menu');
  const globalMenuButton = globalMenu?.querySelector(':scope > summary');
  document.addEventListener('pointerdown', event => {if (globalMenu?.open && !globalMenu.contains(event.target)) globalMenu.open = false;});
  document.addEventListener('keydown', event => {if (event.key === 'Escape' && globalMenu?.open) {globalMenu.open = false;globalMenuButton?.focus({preventScroll:true});event.preventDefault();}});
  for (const nav of document.querySelectorAll('.clu-menu,#cls-nav')) new MutationObserver(() => {
    const menuOpen = Boolean(globalMenu?.open || document.querySelector('#cls-nav.is-open'));
    document.body.classList.toggle('clux-menu-open', menuOpen);
  }).observe(nav, {attributes:true, attributeFilter:['open','class']});
  sync();
  if(!document.querySelector('shopify-chat')?.shadowRoot) {discovery=new MutationObserver(schedule);discovery.observe(document.body,{childList:true,subtree:true});window.addEventListener('load',schedule,{once:true});}
})();
